import React, { useEffect, useState } from "react";

import {
  getOrderParties,
  getParties,
} from "../../features/newJobwork/newJobworkSlice";
import { useAppSelector } from "../../app/hooks";
import { OrderPartyProps, PartyProps } from "../../types/jobwork";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { GiCancel } from "react-icons/gi";
import { OptionsProps } from "../../types/order";
import Select from "react-select";
import { selectStyles } from "../../static/styles";

type PartiesFormProps = {
  index: number;
};

const PartiesForm = ({ index }: PartiesFormProps) => {
  const orderParties = useAppSelector(getOrderParties);

  const {
    control,
    register,
    setValue,
    clearErrors,
    formState: { errors },
  } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control: control,
    name: `items.${index}.order_parties`,
  });

  const [orderPartiesOption, setOrderPartiesOption] = useState<OptionsProps[]>(
    []
  );

  const handleChangeOrderParty = (
    order_party_id: string,
    partyIndex: number
  ) => {
    setValue(
      `items.${index}.order_parties.${partyIndex}.order_party_id`,
      order_party_id
    );
    clearErrors(`items.${index}.order_parties.${partyIndex}.order_party_id`);
  };

  useEffect(() => {
    setOrderPartiesOption(
      orderParties?.map((party: OrderPartyProps) => ({
        value: party.id,
        label:
          party.firm_name +
          (party.name ? " - " + party.name : "") +
          (party.phone ? " (" + party.phone + ")" : ""),
      })) || []
    );
  }, [orderParties]);

  return (
    <div className="grid">
      {fields.map((field, partyIndex) => (
        <div className="mt-6 relative" key={field.id}>
          <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 w-full relative rounded">
            <Controller
              {...register(
                `items.${index}.order_parties.${partyIndex}.order_party_id`,
                {
                  required: true,
                  min: 1,
                }
              )}
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  value={
                    orderPartiesOption.find(
                      (val) => val.value === field?.value
                    ) || null
                  }
                  className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                  styles={selectStyles}
                  placeholder={"પાર્ટી નું નામ સિલેક્ટ કરો"}
                  options={orderPartiesOption}
                  onChange={(val: any) =>
                    handleChangeOrderParty(val?.value, partyIndex)
                  }
                />
              )}
            />
          </div>
          {Array.isArray(errors?.items) &&
            errors.items[index]?.order_parties &&
            errors.items[index]?.order_parties[partyIndex] &&
            errors.items[index]?.order_parties[partyIndex]?.order_party_id && (
              <span className="text-red-500">પાર્ટી નું નામ સિલેક્ટ કરો</span>
            )}

          {partyIndex > 0 && (
            <GiCancel
              onClick={() => remove(partyIndex)}
              className="absolute z-10 shadow bg-white top-4 right-2 cursor-pointer text-3xl text-primary-1 border-2 border-primary-1 p-1 rounded-full"
            />
          )}
        </div>
      ))}

      <button
        className="ml-auto mt-4 shadow rounded-3xl text-lg bg-white text-primary-1 border-2 border-primary-1 font-bold px-5 py-1"
        type="button"
        onClick={() => append({ order_party_id: 0 })}
      >
        પાર્ટી ઉમેરો
      </button>
    </div>
  );
};
export default PartiesForm;
